import { Component, OnInit, ViewChild } from '@angular/core';
import { DxoGridComponent } from 'devextreme-angular/ui/nested';
import { alert } from 'devextreme/ui/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnagraficaService } from '../../services/anagrafica.service';
import { RentriService } from '../../services/rentri.service';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';

@Component({
  selector: 'app-configurazione-rentri',
  templateUrl: './configurazione-rentri.component.html',
  styleUrls: ['./configurazione-rentri.component.css']
})
export class ConfigurazioneRentriComponent implements OnInit {

  @ViewChild('configurazioneRentri', { static: false }) configurazioneRentri: NicaAnagraficaComponent;
  @ViewChild('configurazionePosizioniRentri', { static: false }) configurazionePosizioniRentri: NicaAnagraficaComponent;
  @ViewChild('gridCausali', { static: false }) gridCausali: DxoGridComponent;

  filterGrid: string;
  api: string;
  masteKey: string;
  service: string;
  showDynamicContent: boolean = false;
  showGridCausali: boolean = false;
  showGridPosizionCausali: boolean = false;
  causaleRifiuti: any[] = [];
  tipoOperazione: any[] = [];
  currentRowIndex: number;
  currentSedeData: any[] = [];
  apiSource: string;
  componentType: string;
  componentName: string;
  componentData: any[] = [];
  idCausale: any;
  dynamicApi: string;
  dynamicService: string;
  dynamicFilter: string;
  titleDynamicPopUp: string;
  constructor(private rentriService: RentriService, private loader: NgxSpinnerService, private anagraficaService: AnagraficaService) { }



  ngOnInit() {

    this.filterGrid = '?codicefiscale=';
    this.api = 'Sede/GetSediNsAziende';
    this.masteKey = 'id'

    this.service = 'ConfigurazioneRentri';
    this.anagraficaService.getElenco('TipoOperazioneCausaleRifiuti').then(res => {
      this.tipoOperazione = res['items']
    })


  }
  optionalButtonEvent(ev) {
    console.log('optionalButtonEvent',ev)
    if (ev.name == 'AssociaSedeRentri' && ev.componentName == 'configurazioneRentri') {
      this.componentName = ev.componentName
      this.loader.show()

      this.currentSedeData = ev.row.data;
      this.currentRowIndex = ev.row.rowIndex

      this.rentriService.loginRentriSede(this.currentSedeData['id']).then(res => {

        if (res) {
          this.dynamicApi = "RentriOld/getStruttureElenco";
          this.dynamicService = "serviceRentriSede";
          this.titleDynamicPopUp = "Unità locali R.E.N.T.Ri"
          this.componentData['dynamic'] = {

            componentType: 'grid',
            enableEditor: false,

          }
          this.loader.hide()
          this.showDynamicContent = true;
          //alert('sei loggato ' + res)
        } else {
          this.loader.hide();
          alert('Nessuna Configurazione', 'Attenzione!')
        }
      })



    }


    if (ev.name == 'RimuoviSedeRentri' && ev.componentName == 'configurazioneRentri') {

      this.componentName = ev.componentName
      this.loader.show()

      this.currentSedeData = ev.row.data;
      this.currentRowIndex = ev.row.rowIndex

      this.rentriService.loginRentriSede(this.currentSedeData['id']).then(res => {

        if (res) {

          const dataFieldidSedeRentri = 'idSedeRentri';



          this.currentSedeData[dataFieldidSedeRentri] = '';



          this.anagraficaService.actionPut('Sede', this.currentSedeData).then(res => {
            this.configurazioneRentri.refresh();
            this.loader.hide();
          })



        } else {
          this.loader.hide();
          alert('Nessuna Configurazione', 'Attenzione!')
        }
      })
    }






  }

  optionalButtonEventPosizioniRentri(event) {
    if (event.name == 'AssociaRegistriRentri' && event.componentName == 'configurazionePosizioniRentri') {
      this.componentName = event.componentName
      this.loader.show()
      let idSede = 1;
      this.currentSedeData = event.row.data;
      this.rentriService.loginRentriSede(idSede).then(res => {

        if (res) {

          this.dynamicApi = "RentriOld/getRegistriElencoBySede?idSede=" + idSede;
          this.dynamicService = "serviceRentriRegistriElenco";
          console.log('currentSedeData', this.currentSedeData)
          this.titleDynamicPopUp = "Lista registri R.E.N.T.R.i"
          this.componentData['dynamic'] = {

            componentType: 'grid',

            enableEditor: false,



          }
          this.loader.hide()
          this.showDynamicContent = true;
          //alert('sei loggato ' + res)
        } else {
          this.loader.hide();
          alert('Nessuna Configurazione', 'Attenzione!')
        }
      })

    }
  }

  /*** Eventi TabPanel ***/

  onClickTab(ev) {

    const item = ev.addedItems[0]['template']
    if (item == 'configurazioneRentriRegistro') {



      this.anagraficaService.getElenco('CausaleRifiuti').then(res => {

        this.causaleRifiuti = res['items'];

        this.showGridCausali = true

        //this.gridCausali.instance.refresh();
      })
    }
  }

  setCellValue(rowData: any, value: any) {
    alert('sss', 'sss')
    console.log(rowData);
    console.log(value);
  }

  onCollapsingCausaleRifiuti(event) {
    /*
      "idRegistroRentriScarico": "string",
      "idRegistroRentriCarico": "string",
      "idRegistroRentriTrasporto": "string",
      "idRegistroRentriIntermediario": "string",
      "registrazioneRegistroRentriScarico": "string",
      "registrazioneRegistroRentriCarico": "string",
      "registrazioneRegistroRentriTrasporto": "string",
      "registrazioneRegistroRentriIntermediario": "string",

      [fixed]="false" [showInColumnChooser]="false" dataField="{{colonna.dataField}}" caption='' type="buttons" [width]="150">
            <!--dxi-item
            [visible]="isCloneIconVisible"
               [itemType]="'button'"                 
              [buttonOptions]="itemOptions"                
              ></dxi-item-->
            <dxi-button hint="{{colonna.button.hint}}" [text]="colonna.button.text" [stylingMode]="colonna.button.type" icon="{{colonna.button.icon}}" name="{{colonna.button.name}}"
              [onClick]="OptionalIconButtonClick"> </dxi-button>
          </dxi-column>
    
    */

    this.configurazionePosizioniRentri.refresh()
  }

  onClickCausaleRifiuti(event) {
    const data = event.data

    this.idCausale = '?idCausale=' + data.id;
    /*const colOptions={
      fixed:false,
      showInColumnChooser:false,
      type:'button',
      width:150,
      text:'newButton'

    }


      this.configurazionePosizioniRentri.griglia.instance.addColumn(colOptions)*/
    //this.configurazionePosizioniRentri.refresh()
  }


  /***Eventi componente dinamico di selezione**/

  emittendSelectionRow(e: any) {

    console.log(e)

    /**valueExpr: 'identificativo',//Lasciato Vuoto sen non serve l'id del DB
      displayExpr: 'identificativo',
      caption: "Lista Sedi R.E.N.T.R.i",
      related: ['nome|sedeRentriDescrizione'], */
    if (e && this.componentName == 'configurazioneRentri') {
      this.toolbarEvent('close')
      const rowIndex = this.currentRowIndex;
      const dataFieldidSedeRentri = 'idSedeRentri';



      this.currentSedeData[dataFieldidSedeRentri] = e.identificativo;



      //console.log(this.currentSedeData)

      this.anagraficaService.actionPut('Sede', this.currentSedeData).then(res => {
        this.configurazioneRentri.refresh();
      })
      //this.configurazioneRentri.refresh();
    }

    if (e && this.componentName == 'configurazionePosizioniRentri') {

      this.toolbarEvent('close');
      console.log(e);
      console.log(this.currentSedeData);

      const dataSede = this.currentSedeData

      /*

      idDestinatario:1 //Carico
      idIntermediario:1 //Carico
      idProduttore:1    //Scarico
      
      
      idRegistroRentriCarico:null
      idRegistroRentriIntermediario:null
      idRegistroRentriScarico:null
      idRegistroRentriTrasporto:null
      

      */

      if (dataSede['idDestinatario'] != '') {
        let idRegistroRentriCarico = e.identificativo;
        let idRegistroRentriScarico = e.identificativo;
        this.currentSedeData['idRegistroRentriCarico'] = idRegistroRentriCarico
        this.currentSedeData['idRegistroRentriScarico'] = idRegistroRentriScarico
      }

      if (dataSede['idIntermediario'] != '') {

        let idRegistroRentriIntermediario = e.identificativo;
        this.currentSedeData['idRegistroRentriIntermediario'] = idRegistroRentriIntermediario
      }
      if (dataSede['idProduttore'] != '') {

        let idRegistroRentriScarico = e.identificativo;
        let idRegistroRentriCarico = e.identificativo;
        this.currentSedeData['idRegistroRentriScarico'] = idRegistroRentriScarico;
        this.currentSedeData['idRegistroRentriCarico'] = idRegistroRentriCarico;
      }
      if (dataSede['idTrasportatore'] != '') {

        let idRegistroRentriTrasporto = e.identificativo;

        this.currentSedeData['idRegistroRentriTrasporto'] = idRegistroRentriTrasporto;
      }




      this.anagraficaService.actionPut('PosizioneCausale', this.currentSedeData).then(res => {
        this.configurazionePosizioniRentri.refresh();
      })

    }
  }

  toolbarEvent(e) {

    if (e == 'close') {

      this.apiSource = '';
      this.componentType = "";
      this.componentData = [];
      this.showDynamicContent = false;


    }


  }

  showingPopUp(e) {

    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    e.component.content().classList.add("formEditPopupContet"); //add class to content
    e.component.content().classList.add("bg-grey"); //add class to content


  }



  AllEvent(event) {

    //console.log(event)
  }
}
